import React from 'react'
import { Edit, useForm, useSelect } from '@refinedev/antd'
import { Form, Input, Switch, Select } from 'antd'
import type { Tables } from '@muaa/shared'

type Mentorship = Tables<'mentorships'>
type Profile = Tables<'profiles'>

export function MentorshipEdit() {
  const { formProps, saveButtonProps } = useForm<Mentorship>()

  const { selectProps: profileSelectProps } = useSelect<Profile>({
    resource: 'profiles',
    optionLabel: 'name',
    optionValue: 'user_id',
    pagination: { mode: 'off' },
  })

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <Form.Item label="Member" name="user_id" rules={[{ required: true }]}>
          <Select
            {...profileSelectProps}
            placeholder="Select member"
            showSearch
            filterOption={(input, option) =>
              String(option?.label ?? '')
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          />
        </Form.Item>

        <Form.Item label="Headline" name="headline">
          <Input placeholder="e.g. Senior Engineer at Acme" />
        </Form.Item>

        <Form.Item
          label="Available"
          name="available"
          valuePropName="checked"
        >
          <Switch />
        </Form.Item>
      </Form>
    </Edit>
  )
}
